import type { ConfirmationServiceMethods } from 'primevue/confirmationservice';
import type { ConfirmationOptions, ToastOptions } from '../types/common';

const nuxtApp = useNuxtApp();
export const getConfirm = () => nuxtApp.vueApp.config.globalProperties.$confirm as ConfirmationServiceMethods;
const getToast = () => nuxtApp.vueApp.config.globalProperties.$toast;

export const notifyToast = ({
    severity,
    summary,
    detail,
    life,
    group
}: ToastOptions): void => {
    getToast().add({
        severity,
        summary,
        detail,
        life,
        group,
        styleClass: 'toast-notification'
    });
};

export const notifyError = (detail: string, group: string | undefined = undefined): void => {
    notifyToast({
        severity: 'error',
        summary: 'Error Message',
        detail,
        group,
        life: 3000
    });
};

export const notifySuccess = (detail: string, summary?: string): void => {
    notifyToast({
        severity: 'success',
        summary: summary || 'Success Message',
        detail,
        life: 3000
    });
};

export const notifyWarning = (detail: string, summary?: string): void => {
    notifyToast({
        severity: 'warn',
        summary: summary || 'Warning Message',
        detail,
        life: 3000
    });
};

export const requireConfirmation = ({
    group,
    icon,
    header,
    message,
    accept,
    reject,
    rejectLabel,
    acceptLabel,
    acceptDisabled,
    showRejectButton
}: ConfirmationOptions): void => {
    const confirmation = {
        group,
        icon,
        header,
        message,
        accept,
        reject,
        rejectLabel,
        acceptLabel,
        acceptDisabled,
        showRejectButton
    };

    getConfirm().require(confirmation as never);
};

export const confirmAction = ({
    header,
    message,
    accept,
    reject,
    rejectLabel,
    acceptLabel,
    acceptDisabled,
    icon,
    showRejectButton = true
}: {
    header?: string, 
    message: string, 
    accept: () => void, 
    reject?: () => void | undefined,
    rejectLabel?: string,
    acceptLabel?: string,
    acceptDisabled?: boolean,
    icon?: string | false,
    showRejectButton?: boolean
}): void => {
    requireConfirmation({
        group: 'headless',
        header: header || '',
        message,
        accept,
        icon: icon === false ? undefined : (icon || 'pi pi-exclamation-triangle'),
        reject: reject || (async () => {}),
        rejectLabel,
        acceptLabel,
        acceptDisabled,
        showRejectButton
    });
};
